import React, { useEffect, useState } from "react";
import axiosInstance from "../../../axiosInstance";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import toast from "react-hot-toast";

const EditJobRoleCategory = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    status: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const getCategory = async () => {
    try {
      const { data } = await axiosInstance.get(
        `/admin/get-job-role-category/${slug}`
      );
      setFormData({
        name: data.JobRoleCategory?.name || "",
        status: Boolean(data.JobRoleCategory?.status),
      });
    } catch (error) {
      toast.error("Error fetching job role category!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  const submitData = async () => {
    setSubmitLoading(true);
    try {
      await axiosInstance.put(`/admin/update-job-role-category/${slug}`, formData);
      toast.success("Job Role Category updated successfully!");
      navigate("/all-job-role-category");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to update category");
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4 d-flex justify-content-between w-100 flex-wrap">
          <div>
            <h1 className="h4">Edit Job Role Category</h1>
          </div>
          <Link to="/all-job-role-category" className="btn btn-primary">
            Go back
          </Link>
        </div>
        {loading ? (
          <div>Loading...</div>
        ) : (
          <div className="row">
            <div className="col-md-8 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">
                  <div className="mb-4">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      value={formData.name}
                      name="name"
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card border-0 shadow components-section">
                <div className="card-body">
                  <div className="row">
                    <div className="col-4">
                      <label className="my-1 me-2" htmlFor="status">
                        Status
                      </label>
                    </div>
                    <div className="col-8">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="status"
                          id="status"
                          checked={formData.status}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    className="btn btn-secondary mt-3"
                    type="button"
                    onClick={submitData}
                    disabled={submitLoading}
                  >
                    {submitLoading ? "Loading..." : "Update Job Role Category"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default EditJobRoleCategory;
